import CustomerDto from "./components/Common/dtos/CustomerDto";

export function toDisplayFromCamelCase(string: string) {
  return capitalizeFirstLetter(string.replace(/([A-Z])/g, ' $1'))
}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function customerDisplayNameFromDto(customer: CustomerDto) {
  return customerDisplayName(customer.name, customer.accountNumber);
}

export function customerDisplayName(name: string, accountNumber: string | undefined) {
  return name + (accountNumber ? ` - ${accountNumber}` : '');
}

export function joinNonEmptyString(array: (string | null | undefined)[], joinString: string = ", ") {
  return array.filter(i => [i].join(" ").trim().length > 0).join(joinString);
}

export function removeEmptyFields(obj: any) {
  for (var propName in obj) {
    // Short circuit so that 0 isn't removed
    if (typeof obj[propName] === 'number') { continue; }

    if (!obj[propName] || obj[propName] === "00000000-0000-0000-0000-000000000000") {
      delete obj[propName];
    }
  }
  return obj;
}

// Sorts objects in a human-friendly way using case-insensitive natural order sorting.
// Examples:
// - Bay 1, Bay 2, Bay 10 will be sorted as: Bay 1, Bay 2, Bay 10 (not Bay 1, Bay 10, Bay 2).
// - Apple, Banana, apple, banana will be sorted as: Apple, apple, Banana, banana 
//   (instead of Apple, Banana, apple, banana).
export const humanReadableSort = <T>(items: T[], field: keyof T) =>
  [...items].sort((a, b) => humanReadableSortCriteria(String(a[field] ?? ''), String(b[field] ?? '')));

export const humanReadableStringSort = (items: string[]) =>
  [...items].sort(humanReadableSortCriteria);

const humanReadableSortCriteria = (a: string, b: string) =>
  a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });

export const dateSort = <T>(items: T[], field: keyof T) =>
  [...items].sort((a, b) =>
    new Date(String(b[field])).getTime() - new Date(String(a[field])).getTime());

export const dateSortReverse = <T>(items: T[], field: keyof T) =>
  [...items].sort((a, b) =>
    new Date(String(a[field])).getTime() - new Date(String(b[field])).getTime());

export const calculateSimilarity = (str1: string, str2: string): number => {
  const s1 = str1.toLowerCase().replace(/[^a-z0-9]/g, '');
  const s2 = str2.toLowerCase().replace(/[^a-z0-9]/g, '');

  if (s1 === s2 || s1.includes(s2) || s2.includes(s1)) return 1;

  const tokens1 = str1.toLowerCase().split(/\s+/);
  const tokens2 = str2.toLowerCase().split(/\s+/);
  const commonTokens = tokens1.filter(t => tokens2.includes(t)).length;
  const totalTokens = Math.max(tokens1.length, tokens2.length);

  return commonTokens / totalTokens;
};
